const URL_BASE=process.env.REACT_APP_API;

export const URL_DOCUMENTS_LIST=`${URL_BASE}/document`;